import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const ShopFavoritesList = () => {
  const [ProductUser, setProductUser] = useState([]);
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);

  const navigate = useNavigate();

  // PAGINATION
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = ProductUser.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(ProductUser.length / itemsPerPage);

  const paginate = (pageNumber) => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  // ===================== FETCH ALL DATA =====================
  useEffect(() => {
    const fetchAll = async () => {
      try {
        // Categories
        const catRes = await axios.get(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_main_category"
        );
        if (catRes.data.status === "true" || catRes.data.status === true) {
          setCategories(catRes.data.row);
        }

        // Subcategories
        const subRes = await axios.get(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_main_subcategory"
        );
        if (subRes.data.status === "true" || subRes.data.status === true) {
          setSubcategories(subRes.data.row);
        }

        // Products
        // Products
const prodRes = await axios.get(
  "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_create_product"
);

if (prodRes.data.status === true || prodRes.data.status === "true") {
  const filtered = prodRes.data.data.filter(
    (item) => item.product_status === "Shop Your Favorites"
  );
  setProductUser(filtered);
} else {
  toast.error("Failed to fetch product list!");
}

      } catch (error) {
        console.error("Error fetching:", error);
        toast.error("Error fetching product list.");
      }
    };

    fetchAll();
  }, []);

  // Convert Category ID → Name
  const getCategoryName = (id) => {
    const category = categories.find((c) => String(c.category_id) === String(id));
    return category ? category.category_name : "-";
  };

  // Convert Subcategory ID → Name
  const getSubCategoryName = (id) => {
    const sub = subcategories.find((s) => String(s.subcategory_id) === String(id));
    return sub ? sub.subcategory_name : "-";
  };

  // ===================== DELETE PRODUCT =====================
  const deleteUser = async (userId) => {
    const formData = new FormData();
    formData.append("product_id", userId);

    try {
      const response = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/delete_create_product",
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (response.data.status === "true" || response.data.status === true) {
        setProductUser((prev) =>
          prev.filter((user) => user.product_id !== userId)
        );
        toast.success(response.data.message || "Product deleted successfully!");
      } else {
        toast.error(response.data.message || "Delete failed.");
      }
    } catch (error) {
      console.error("Delete error:", error);
      toast.error("Failed to delete product.");
    }
  };

  // ===================== STATUS HANDLING FIX =====================
 const getStatusUI = (statusValue) => {
  let text = "Out of Stock";
  let css = "bg-danger-subtle text-danger";

  if (statusValue === "In Stock") {
    text = "In Stock";
    css = "bg-success-subtle text-success";
  }
  if (statusValue === "Few Left") {
    text = "Few Left";
    css = "bg-warning-subtle text-warning";
  }

  return { text, css };
};


  return (
    <div className="page-content">
      <div className="container-fluid">
        {/* PAGE TITLE */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Shop your Favorites List</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to="#">Product</Link>
                </li>
                <li className="breadcrumb-item active">Shop your Favorites List</li>
              </ol>
            </div>
          </div>
        </div>

        {/* TABLE SECTION */}
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-header d-flex flex-wrap justify-content-between align-items-center gap-1">
                <h4 className="card-title flex-grow-1">All Shop your Favorites List</h4>
                <Link to="/product-add" className="btn btn-sm btn-primary">
                  Add Product
                </Link>
              </div>

              <div>
                <div className="table-responsive">
                  <table className="table align-middle mb-0 table-hover table-centered">
                    <thead className="bg-light-subtle">
                      <tr>
                        <th style={{ width: 20 }}>
                          <div className="form-check ms-1 fs-16">
                            <input type="checkbox" className="form-check-input" />
                          </div>
                        </th>
                        <th>Product Name & Size</th>
                        <th>Product Category</th>
                        <th>Sub Category</th>
                        <th>Current Price</th>
                        <th>Old Price</th>
                        <th>Stock</th>
                        <th>Rating</th>
                        <th>Vendor</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>

                    <tbody>
                      {currentItems.length > 0 ? (
                        currentItems.map((user) => {
                          const statusData = getStatusUI(user.status);

                          return (
                            <tr key={user.product_id}>
                              <td>
                                <div className="form-check ms-1 fs-16">
                                  <input type="checkbox" className="form-check-input" />
                                </div>
                              </td>

                              {/* PRODUCT IMAGE + NAME */}
                              <td>
                                <div className="d-flex align-items-center gap-2">
                                  <div className="rounded bg-light avatar-md d-flex align-items-center justify-content-center">
                                    <img
                                      src={
                                        user.multi_image && user.multi_image.length > 0
                                          ? `https://cyberathon.com/multivendor/${user.multi_image[0]}`
                                          : "https://via.placeholder.com/80x80?text=No+Image"
                                      }
                                      alt={user.product_name}
                                      className="avatar-md"
                                    />
                                  </div>

                                  <div>
                                    <span className="text-dark fw-medium fs-15">
                                      {user.product_name || "N/A"}
                                    </span>
                                    <p className="text-muted mb-0 mt-1 fs-13">
                                      Size: {user.available_size || "N/A"}
                                    </p>
                                  </div>
                                </div>
                              </td>

                              {/* CATEGORY */}
                              <td>{getCategoryName(user.category_id)}</td>

                              {/* SUBCATEGORY */}
                              <td>{getSubCategoryName(user.subcategory_id)}</td>

                              <td>{user.current_price}</td>
                              <td>{user.old_price || "-"}</td>

                              {/* STOCK */}
                              <td>
                                <span className="text-dark fw-medium">
                                  {user.stock} Items
                                </span>
                              </td>

                              <td>{user.rating || "-"}</td>
                              <td>{user.assign_vendor || "-"}</td>

                              {/* STATUS FIXED */}
                              <td>
                                <span className={`badge ${statusData.css} py-1 px-2`}>
                                  {statusData.text}
                                </span>
                              </td>

                              {/* ACTION BUTTONS */}
                              <td>
                                <div className="d-flex gap-2">
                                  <Link
                                    to={`/product-detail/${user.product_id}`}
                                    className="btn btn-light btn-sm"
                                  >
                                    <i className="fa-solid fa-eye fs-18"></i>
                                  </Link>

                                  <Link
                                    to={`/product-edit/${user.product_id}`}
                                    className="btn btn-soft-primary btn-sm"
                                  >
                                    <i className="fa-solid fa-pencil fs-18"></i>
                                  </Link>

                                  <span
                                    onClick={() => deleteUser(user.product_id)}
                                    className="btn btn-soft-danger btn-sm"
                                    style={{ cursor: "pointer" }}
                                  >
                                    <i className="fa-solid fa-trash fs-18"></i>
                                  </span>
                                </div>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="12" className="text-center py-3">
                            No Products Found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* PAGINATION */}
              <div className="card-footer border-top">
                <nav aria-label="Page navigation example">
                  <ul className="pagination justify-content-end mb-0">
                    <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                      <span className="page-link" onClick={() => paginate(currentPage - 1)}>
                        Previous
                      </span>
                    </li>

                    {[...Array(totalPages)].map((_, index) => (
                      <li
                        key={index}
                        className={`page-item ${currentPage === index + 1 ? "active" : ""}`}
                      >
                        <span className="page-link" onClick={() => paginate(index + 1)}>
                          {index + 1}
                        </span>
                      </li>
                    ))}

                    <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                      <span className="page-link" onClick={() => paginate(currentPage + 1)}>
                        Next
                      </span>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* FOOTER */}
      <footer className="footer">
        <div className="container-fluid text-center">
          © Venton. Crafted with ❤️ by <strong>Techzaa</strong>
        </div>
      </footer>
    </div>
  );
};

export default ShopFavoritesList;
